class Ripple {
  constructor ({ canvas, info, mousePos, radius, ratio }) {
    this.canvas = canvas;
    this.ctx = this.canvas.getContext('2d');
    this.info = info;
    this.radius = radius;
    this.ballWidth = window.innerWidth >= 1440 ? 13 : 8
    this.ballInnerWidth = window.innerWidth >= 1440 ? 8 : 5
    this.ratio = ratio;
    this.curvePoints = this.info.curvePoints;
    this.cpElList = [];
    this.mousePos = mousePos;
    this.defaultMousePos = mousePos;
    this.url = '';
    
    this.initCurvePoints();
    this.initEvent();
    this.initAnimation();
  }

  initAnimation () {
    window.requestAnimationFrame(() => {
      this.initAnimation();
    });
    this.renderAnimation();
  }

  initCurvePoints () {
    const canvasParent = this.canvas.parentElement;
    this.curvePoints.forEach(p => {
      p.ox = p.ox * this.ratio;
      p.oy = p.oy * this.ratio;
      p.ocp1x = p.ocp1x * this.ratio;
      p.ocp1y = p.ocp1y * this.ratio;
      p.ocp2x = p.ocp2x * this.ratio;
      p.ocp2y = p.ocp2y * this.ratio;
      p.cp1x = p.ocp1x;
      p.cp1y = p.ocp1y;
      p.cp2x = p.ocp2x;
      p.cp2y = p.ocp2y;
      p.x = p.ox;
      p.y = p.oy;
      p.opacity = 0;

      const cpEl = document.createElement('div');
      cpEl.classList.add('ripple-ball-each', p.align);
      cpEl.setAttribute('data-url', p.url);
      cpEl.innerHTML = `<div class="ripple-ball-each-inside"></div><p>${p.text}</p>`;

      canvasParent.appendChild(cpEl);
      this.cpElList.push(cpEl);
    });
  }

  renderAnimation () {
    this.url = '';
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.curvePoints.forEach((p, i) => {
      const distPointCircle = Math.sqrt((this.mousePos.x - (this.canvas.width / 2)) * (this.mousePos.x - (this.canvas.width / 2)) + (this.mousePos.y - 405) * (this.mousePos.y - 405));
      let distPoint1 = Math.sqrt((this.mousePos.x - p.ocp1x) * (this.mousePos.x - p.ocp1x) + (this.mousePos.y - p.ocp1y) * (this.mousePos.y - p.ocp1y));

      if (distPoint1 < this.radius) {
        distPoint1 = 1 - distPoint1 / (this.radius);
        p.isAnimating1 = false;
        TweenLite.to(p, 1, {
          cp1x: p.ocp1x + ((this.mousePos.x - p.ocp1x) * distPoint1),
          cp1y: p.ocp1y + ((this.mousePos.y - p.ocp1y) * distPoint1)
        }, 0);
      } else {
        if (!p.isAnimating1) {
          p.isAnimating1 = true;
          TweenLite.to(p, 1, {
            cp1x: p.ocp1x,
            cp1y: p.ocp1y,
            ease: d3.easeElasticOut,
            onComplete () {
              p.isAnimating1 = false;
            }
          }, 3000);
        }
      };

      let distPoint2 = Math.sqrt((this.mousePos.x - p.ocp2x) * (this.mousePos.x - p.ocp2x) + (this.mousePos.y - p.ocp2y) * (this.mousePos.y - p.ocp2y));
      if (distPoint2 < this.radius) {
        distPoint2 = 1 - distPoint2 / (this.radius);
        p.isAnimating2 = false;
        TweenLite.to(p, 1, {
          cp2x: p.ocp2x + ((this.mousePos.x - p.ocp2x) * distPoint2),
          cp2y: p.ocp2y + ((this.mousePos.y - p.ocp2y) * distPoint2)
        }, 0);
      } else {
        if (!p.isAnimating2) {
          p.isAnimating2 = true;
          TweenLite.to(p, 1, {
            cp2x: p.ocp2x,
            cp2y: p.ocp2y,
            ease: d3.easeElasticOut,
            onComplete () {
              p.isAnimating2 = false;
            }
          }, 3000);
        }
      };

      this.cpElList[i].classList.remove('show');

      let distPoint3 = Math.sqrt((this.mousePos.x - p.ox) * (this.mousePos.x - p.ox) + (this.mousePos.y - p.oy) * (this.mousePos.y - p.oy));
      if (distPoint3 < this.radius) {
        if (distPoint3 < this.radius / 2) {
          this.cpElList[i].classList.add('show');
          TweenLite.to(p, 1, {
            opacity: 1
          }, 0);
          this.url = p.url;
        };
        distPoint3 = 1 - distPoint3 / (this.radius);
        p.isAnimating3 = false;
        TweenLite.to(p, 1, {
          x: p.ox + ((this.mousePos.x - p.ox) * distPoint3),
          y: p.oy + ((this.mousePos.y - p.oy) * distPoint3)
        }, 0);
      } else {
        if (!p.isAnimating3) {
          p.isAnimating3 = true;
          TweenLite.to(p, 1, {
            x: p.ox,
            y: p.oy,
            ease: d3.easeElasticOut,
            onComplete () {
              p.isAnimating3 = false;
            }
          }, 3000);
          TweenLite.to(p, 1, {
            opacity: 0
          }, 300);
        }
      }
    });

    const objX = this.curvePoints[this.curvePoints.length - 1].x;
    const objY = this.curvePoints[this.curvePoints.length - 1].y;
    this.ctx.beginPath();
    this.ctx.moveTo(objX, objY);
    this.curvePoints.forEach(p => {
      this.ctx.bezierCurveTo(p.cp1x, p.cp1y, p.cp2x, p.cp2y, p.x, p.y);
    });
    this.ctx.lineWidth = 2;
    this.ctx.strokeStyle = '#fff';
    this.ctx.stroke();
    const bound = this.canvas.getBoundingClientRect();
    this.curvePoints.forEach((p, i) => {
      this.ctx.beginPath();
      this.ctx.arc(p.x, p.y, this.ballWidth, 0, 2 * Math.PI, false);
      this.ctx.fillStyle = '#fff';
      this.ctx.fill();
      this.ctx.beginPath();
      this.ctx.arc(p.x, p.y, this.ballInnerWidth, 0, 2 * Math.PI, false);
      this.ctx.fillStyle = `rgba(${this.info.color},${window.getComputedStyle(this.cpElList[i].querySelector('.ripple-ball-each-inside')).opacity})`;
      this.ctx.fill();
      this.cpElList[i].style.left = bound.left + p.x;
      this.cpElList[i].style.top = bound.top + p.y;
    });
    this.canvas.style.cursor = this.cpElList.filter(e => e.classList.contains('show')).length > 0 ? 'pointer' : 'default';
  }

  initEvent () {
    this.canvas.addEventListener('mousemove', (e) => {
      const bound = this.canvas.getBoundingClientRect();
      this.setMousePos({
        x: e.clientX - bound.left,
        y: e.clientY - bound.top
      });
    }, false);
    this.canvas.addEventListener('mouseleave', (e) => {
      this.setMousePos({
        ...this.defaultMousePos
      });
    }, false);
    this.canvas.addEventListener('click', (e) => {
      if (this.url != '') {
        // window.location.href = this.url;
      }
    }, false);
  }

  setMousePos (pos) {
    this.mousePos = pos;
  }
}

export default Ripple;